import {useState, useCallback} from 'react'
import {createServiceProxy} from 'background-removal'

const service = createServiceProxy({modelId: 'rmbg-1.4'})
let warmedUp = false

/** Shared service for Sidebar warmup */
export {service as backgroundRemovalService}

export const REMOVE_BG_STATUS = {
    IDLE: 'idle',
    PROCESSING: 'processing',
    PREVIEW: 'preview',
    ERROR: 'error',
}

/**
 * Hook to run background removal on an image URL using the background-removal package.
 * Model is loaded from CDN via modelId (no local model file).
 * Returns status, blob (on success), error, and retry function.
 * @param {string} imageSrc - node.content.src (URL, blob:, or data:)
 * @returns {{ status: REMOVE_BG_STATUS[keyof REMOVE_BG_STATUS], blob: Blob|null, error: Error|null, retry: () => void }}
 */
export function useBackgroundRemoval(imageSrc) {
    const [status, setStatus] = useState(REMOVE_BG_STATUS.IDLE)
    const [blob, setBlob] = useState(null)
    const [error, setError] = useState(null)

    const run = useCallback(async () => {
        if (!imageSrc) {
            setStatus(REMOVE_BG_STATUS.IDLE)
            setBlob(null)
            setError(null)
            return
        }

        setStatus(REMOVE_BG_STATUS.PROCESSING)
        setError(null)
        setBlob(null)

        try {
            if (!warmedUp) {
                await service.warmup()
                warmedUp = true
            }
            const result = await service.removeBackground(imageSrc)
            setBlob(result.blob)
            setStatus(REMOVE_BG_STATUS.PREVIEW)
        } catch (err) {
            setError(err)
            setStatus(REMOVE_BG_STATUS.ERROR)
        }
    }, [imageSrc])

    return {status, blob, error, retry: run}
}
